import React, { useEffect, useState, Fragment } from "react";
import DashboardContainer from "../Common/Components/DashboardContainer";
import { useParams } from "react-router-dom";
import getQueryStringParams from "../Common/Util_methods/queryString";
import { widgetLibrary } from "../Common/Components/widgetLibrary";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";
import { useAppDispatch } from "../Core/store.hooks";
import DashboardSelection from "../Common/Components/DashboardSelection";

interface CustomDashboardOverviewProps {}

const DeviceDashboardOverview = (props: CustomDashboardOverviewProps) => {
  const [loadedDashboard, updateLoadedDashboard] = useState(null);

  const { queryparams } = useParams();
  let urlParams = getQueryStringParams(queryparams);
  const dispatch = useAppDispatch();
    const sidebarItems: { title: string; item: any; expanded: boolean }[] = [
        { title: "Dashboard Selection", item: <DashboardSelection />, expanded: true }];

  useEffect(() => {
    if (urlParams != null && loadedDashboard == null) {
      const decodedString: any = atob(urlParams.token);

      // Parse the decoded string back into an object
        let parsedData: any = JSON.parse(decodedString)[0];
      dispatch(updateParams(parsedData.params));
      parsedData.widgets = createWidgetList(parsedData.widgets);
        parsedData.sidebarItems = sidebarItems;
      updateLoadedDashboard(parsedData);
    }
  }, [urlParams]);
  const createWidgetList = (ids: any) => {
    let widgetList: any = [];
    for (var k = 0; k < ids.length; k++) {
      for (var i = 0; i < widgetLibrary.length; i++) {
        if (ids[k] == widgetLibrary[i].dashboardId) {
          if (ids.indexOf(widgetLibrary[i].dashboardId) > -1) {
            const widgetComponent: JSX.Element = widgetLibrary[i].component({
              key: widgetLibrary[i].dashboardId,
            });
            widgetList = [...widgetList, widgetComponent];
          }
        }
      }
    }
    return widgetList;
  };

 

  const getLoadedDashboardPositionData = () => {
  
    return loadedDashboard.positionData;
  };

  if (loadedDashboard == null) {
    return <div>Loading...</div>;
  }
  return (
    <DashboardContainer
      staticContent={loadedDashboard.staticContent}
      positionData={getLoadedDashboardPositionData()}
      sidebarItems={loadedDashboard.sidebarItems}
      defaultWidgets={loadedDashboard.widgets}
      currentDashboard={""}
    />
  );
};

export default DeviceDashboardOverview;
